import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import {
  RegionFilterOptions,
  DateFilterOptions,
  GroupFilterOptions,
  VersionFilterOptions,
} from "../price-vehicle-filter";
import { SessionService } from "@app/store/session/session.service";
import { UserInfo } from "@app/store/session/session.store";
import { RegionEnum } from "@app-model/pricing";
import { EvaluationVehicle } from "@app-model/evaluation";
import { Vehicle } from "@app-model/vehicle";
@Component({
  selector: "app-price-modal-filter",
  templateUrl: "./price-modal-filter.component.html",
  styleUrls: ["./price-modal-filter.component.scss"],
})
export class PriceModalFilterComponent implements OnInit {
  regions = RegionFilterOptions();

  dates = DateFilterOptions();

  groups = GroupFilterOptions();

  versions = VersionFilterOptions();

  @Output()
  filtersSelects: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  regionSelected? = this.regions[3].value;

  @Input()
  dateSelected? = this.dates[1].value;

  @Input()
  groupSelected? = this.groups[2].value;

  @Input()
  versionSelected? = this.versions[2].value;

  @Input()
  vehicle?: EvaluationVehicle | Vehicle;

  userInfo: UserInfo;

  @Input()
  isEvaluation?;

  constructor(private sessionService: SessionService) {}

  ngOnInit() {
    this.updateComboboxNames();
  }

  updateComboboxNames() {
    this.sessionService.getUser().subscribe((user: UserInfo) => {
      this.userInfo = user;
      // Regions
      this.regions[0].label += ` (${user.city} - ${user.uf})`;
      this.regions[1].label += ` (${user.uf})`;

      // Grupo
      this.groups[1].label += ` (${this.vehicle.oemDealer})`;

      // loja
      if (!this.vehicle.evalDealerName || !this.isEvaluation) {
        // verificar essa parte
        this.groups = this.groups.slice(1);
        this.groupSelected = this.groups[0].value;
      } else {
        this.groups[0].label += ` (${this.vehicle.evalDealerName})`;
        this.groupSelected = this.groups[1].value;
      }

      // Regiao
      if (RegionEnum[user.region]) {
        this.regions[2].label += ` (${RegionEnum[user.region]})`;
      }
      this.emit();
    });
  }

  emit() {
    this.filtersSelects.emit({
      startDate: this.dateSelected,
      dealerFilter: this.groupSelected,
      modelFilter: this.versionSelected,
      region: this.regionSelected,
    });
  }
}
